import store from "@/config/vuex/store";

export default [
    {
        path: "/pagamentos",
        component: () => import('@/pages/Layout/DashboardLayout'),
        children: [
            {
                path: "/",
                name: "pagamentosCreate",
                component: () => import('@/pages/Pagamento/PagamentoCreate'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "cadastrar/:id",
                name: "pagamentosStore",
                component: () => import('@/pages/Pagamento/PagamentoStore')
            },
            {
                path: "fornecedor",
                name: "pagamentosFornecedorRead",
                component: () => import('@/pages/Pagamento/PagamentoFornecedorRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "fornecedor-cancelados",
                name: "pagamentosFornecedorCanceladoRead",
                component: () => import('@/pages/Pagamento/PagamentoFornecedorCanceladoRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "fornecedor-dia",
                name: "pagamentosFornecedorDiaRead",
                component: () => import('@/pages/Pagamento/PagamentoDiaRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "administrativo",
                name: "pagamentosAdministrativoRead",
                component: () => import('@/pages/Pagamento/PagamentoAdministrativoRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "administrativo-cancelados",
                name: "pagamentosAdministrativoCanceladoRead",
                component: () => import('@/pages/Pagamento/PagamentoAdministrativoCanceladoRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "parcelamentos",
                name: "parcelamentosCreate",
                component: () => import('@/pages/Pagamento/ParcelamentoCreate'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "parcelamentos/:id",
                name: "parcelamentosRead",
                component: () => import('@/pages/Pagamento/ParcelamentoRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "cliente",
                name: "pagamentosClienteRead",
                component: () => import('@/pages/Pagamento/PagamentoClienteRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "repasse-fornecedor",
                name: "repasseFornecedorRead",
                component: () => import('@/pages/Pagamento/RepasseFornecedorRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            },
            {
                path: "repasse-fornecedor-sintetico",
                name: "repasseFornecedorSinteticoRead",
                component: () => import('@/pages/Pagamento/RepasseFornecedorSinteticoRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            }
        ]
    }
]

